import { useEffect, useRef, useState } from "react";

// ─── Three-dot Menu ───────────────────────────────────────────────────────────
const ThreeDotMenu = ({
  activeType,
  item,
  onUpdate,
  onRelease,
  onQueueEdit,
  onPriorityEdit,
  onCancel,
  mode,
  managerAuth,
  isSuperAdmin,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // console.log(item);

  // console.log(managerAuth);

  const canUpdateQueueAccess =
    isSuperAdmin || managerAuth?.manageProdQueueAccess === true;

  const isItemWiseOrProductionLineWise =
    activeType === "Item Wise" || activeType === "Production Line Wise";

  const canUpdateProduction =
    item?.status !== "New Voucher" && item?.status !== "Pending";

  const canCancelOrder =
    activeType === "Order Wise"
      ? item?.status === "New Voucher"
      : item?.producedQty === 0;

  const canUpdateQueueAndPriority =
    item?.status !== "Ready For Dispatch" &&
    item?.status !== "Cancelled" &&
    item?.status !== "Dispatched" &&
    item?.status !== "Completed";

  const menuOptions = [
    ...(canUpdateProduction
      ? [
          {
            label: "Update Production",
            action: () => {
              onUpdate(item);
              setOpen(false);
            },
          },
        ]
      : []),

    ...(isItemWiseOrProductionLineWise &&
    (item?.machine || item?.productionLine)
      ? [
          {
            label: "Release Production Line",
            action: () => {
              onRelease(item);
              setOpen(false);
            },
          },
        ]
      : []),

    ...(canUpdateQueueAndPriority && canUpdateQueueAccess
      ? [
          {
            label: "Update Queue No",
            action: () => {
              onQueueEdit(item);
              setOpen(false);
            },
          },
        ]
      : []),

    ...(activeType === "Order Wise" &&
    canUpdateQueueAndPriority &&
    canUpdateQueueAccess
      ? [
          {
            label: "Update Priority",
            action: () => {
              onPriorityEdit(item);
              setOpen(false);
            },
          },
        ]
      : []),

    ...(canCancelOrder && canUpdateQueueAndPriority
      ? [
          {
            label: isItemWiseOrProductionLineWise
              ? "Cancel Production Item"
              : "Cancel Production",
            action: () => {
              onCancel(item);
              setOpen(false);
            },
            danger: true,
          },
        ]
      : []),
  ];

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div
      ref={ref}
      style={{
        flex: 1,
        display: "flex",
        justifyContent: "flex-end",
        position: "relative",
      }}
    >
      <button
        onClick={(e) => {
          e.stopPropagation();
          setOpen((p) => !p);
          // console.log(e);
        }}
        style={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          border: "none",
          backgroundColor: mode ? "#3b3d43" : "#F3F4F6",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
        title="More actions"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="3" r="1.5" fill={mode ? "#fff" : "#374151"} />
          <circle cx="8" cy="8" r="1.5" fill={mode ? "#fff" : "#374151"} />
          <circle cx="8" cy="13" r="1.5" fill={mode ? "#fff" : "#374151"} />
        </svg>
      </button>
      {open && (
        <div
          style={{
            position: "absolute",
            // right: 0,
            // top: 32,
            right: 30,
            top: 0,
            zIndex: 9999,
            backgroundColor: mode ? "#1B1D21" : "#fff",
            border: `1px solid ${mode ? "#3b3d43" : "#E5E7EB"}`,
            borderRadius: 10,
            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
            minWidth: 100,
            overflow: "hidden",
            padding: 5,
          }}
        >
          {menuOptions.map((opt) => (
            <div
              key={opt.label}
              onClick={(e) => {
                e.stopPropagation();
                opt.action();
              }}
              style={{
                padding: 5,
                fontSize: 13,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 8,
                color: opt.danger ? "#F04438" : mode ? "#fff" : "#374151",
                transition: "background 0.15s",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                borderRadius: 10,
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = mode
                  ? "#323336"
                  : "#F3F4F6")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              <span>{opt.icon}</span> {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ThreeDotMenu;
